<template>
  <div class="p-3">
    <fcc-editor v-model="aviso"></fcc-editor>

    <div class="mt-2">
      <fcc-button @click="restaurar" class="mr-2" size="sm" color="outline-secondary"
        >Restaurar Padrão</fcc-button
      >
      <fcc-button @click="alterar" size="sm" color="outline-primary"
        >Definir como novo Texto Padrão</fcc-button
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import fccStore from '@/store'

export default {
  props: ['value'],
  data() {
    return {
      aviso: ''
    }
  },
  mounted() {
    this.restaurar()
  },
  methods: {
    restaurar() {
      this.visualizaAvisoPadrao().then((texto) => {
        this.aviso = texto
      })
    },
    alterar() {
      this.callConfirm(
        'Definir um novo texto padrão para Aviso?',
        'Ao definir um novo texto padrão, esse texto poderá ser usado futuramente, inclusive por outras configurações de local de prova. O texto padrão anterior será excluído.'
      ).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.alteraAvisoPadrao().then(() => {
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.editado, 'success')
          })
        }
      })
    },
    alteraAvisoPadrao() {
      return new Promise((resolve) => {
        const payload = {
          descricao: this.aviso,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }

        axios
          .put(
            fccStore.state.baseUrlLocalDeProva + `LocalExameMensagem/AlteraAvisoPadrao`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(this.setErrorSystem)
      })
    },
    visualizaAvisoPadrao() {
      return new Promise((resolve) => {
        axios
          .get(
            fccStore.state.baseUrlLocalDeProva + `LocalExameApresentacao/VisualizaAvisoPadrao`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch(this.setErrorSystem)
      })
    }
  },
  watch: {
    value() {
      this.aviso = this.value
    },
    aviso: {
      handler() {
        this.$emit('input', this.aviso)
      },
      immediate: true
    }
  }
}
</script>